




















































































































































import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { APIBlacklist } from '@/models/api/blacklist.model'
import moment from 'moment'
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
    components: {
        ConfirmDialog
    }
})
export default class Blacklist extends Vue {
    @Prop({ required: true }) getDateFormat!: () => {};
    @Prop({ required: true }) refreshTrigger!: boolean
    @Prop({ required: false }) providerId!: number
    @Prop({ required: true }) carrierId!: number
    @Prop({ required: true }) formData!: { msisdn: string; provider: null|number; carrier: number }

    localLoading = false

    tables = {
        blacklist: {
            data: [],
            columns: [
                {
                    text: 'ID',
                    value: 'blacklistId'
                },
                {
                    text: 'MSISDN',
                    value: 'blacklistMsisdn'
                },
                {
                    text: 'Expire Date',
                    value: 'blacklistExpireDate'
                },
                {
                    text: 'Actions',
                    value: 'options'
                }
            ]
        }
    }

    blacklistDialog = {
        showDialog: false,
        formValid: false,
        action: 'Add'
    }

    blacklistDialogFormData: {
        blacklistExpireDate: string;
        carrierId: number;
        id: number|null;
    } = {
        blacklistExpireDate: moment().add('years', 1).format('YYYY-MM-DD HH:mm').toString(),
        carrierId: 1,
        id: null
    }

    blacklistDialogFormRules = {
        id: [
            (v: string) => (!!v && v.length > 0) || 'Field is required'
        ]
    }

    confirmDialogData = null
    confirmDialogTrigger = false

    @Watch('refreshTrigger')
    refreshHandler () {
        this.blacklistDialogFormData = {
            blacklistExpireDate: moment().add('years', 1).format('YYYY-MM-DD HH:mm').toString(),
            carrierId: 1,
            id: null
        }
        this.getBlacklist()
    }

    mounted () {
        this.getBlacklist()
    }

    getBlacklist () {
        return new Promise(resolve => {
            this.localLoading = true

            this.$store.dispatch('getBlacklist', {
                carrierId: this.carrierId,
                msisdn: this.formData.msisdn
            })
                .then(resp => {
                    if (resp?.status === 200) {
                        const blacklist = this.$store.state.MonitorStore.blacklist
                        blacklist.forEach((b: { options: object; blacklistExpireDate: string; isExpired: boolean }) => {
                            b.options = {}
                            b.isExpired = (new Date(b.blacklistExpireDate).getTime() - new Date().getTime()) <= 0
                        })
                        this.tables.blacklist.data = blacklist
                        this.localLoading = false
                        this.$emit('localLoadingEnd')
                        resolve()
                    }
                })
        })
    }

    async blacklistDialogConfirm () {
        if (!this.blacklistDialog.formValid) return

        this.blacklistDialog.showDialog = false

        switch (this.blacklistDialog.action) {
        case 'Add':
            this.$store.dispatch('createBlacklist', {
                blacklistMsisdn: this.formData.msisdn,
                blacklistExpireDate: this.blacklistDialogFormData.blacklistExpireDate,
                carrierId: this.formData.carrier
            })
                .then(resp => {
                    if (resp.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.getBlacklist()
                    }
                })
            break
        case 'Delete':
            this.$store.dispatch('deleteBlacklist', this.blacklistDialogFormData.id)
                .then(resp => {
                    if (resp.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.getBlacklist()
                    }
                })
            break
        }
    }

    confirmedDialog (confirmedData: APIBlacklist) {
        this.blacklistDialogFormData.id = confirmedData.blacklistId
        this.blacklistDialog.action = 'Delete'
        this.blacklistDialog.formValid = true
        this.blacklistDialogConfirm()
    }
}

